"use client"
import to from "await-to-js";
import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import {
  queryPostCode,
} from "@/apis/address/address.api";
import { isPostCodeAddress, initAddress, isAddress } from "@/utils/addressUtils";
import LocationError from "@/assets/icons/address/LocationError.svg";
import AddressArrow from "@/assets/icons/address/AddressArrow.svg";
import AddressSelectDrawer from "@/components/address/AddressSelect/AddressSelectDrawer";
import PAGE_TYPE from "@/constants/pageType";
import styles from "./index.module.scss";
import { useStores } from "@/models";

interface DataProps {
  pageType?: typeof PAGE_TYPE[keyof typeof PAGE_TYPE];
}

const FloatBottomTips: React.FC<DataProps> = observer(({ pageType }) => {
  const { countryStore } = useStores();
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [isNotDeliverable, setIsNotDeliverable] = useState(false); //当前postcode是否满足配送范围
  const [postCodeAddress, setPostCodeAddress] = useState<any>();

  useEffect(() => {
    initLocalAddress();
  }, [countryStore.currentCountryData]);

  const initLocalAddress = () => {
    initAddress().then((data) => {
      // 获取缓存postCode
      if (isPostCodeAddress(data)) {
        // 判断postCode是否在配送范围内 isDefaultLocal判断是因为如果默认兜底地址不展示postcode 则不需要展示是否可配送
        getPostCodeDeliverable(!data?.isDefaultLocal ? data?.postCode : "");
        return;
      }
      // 获取缓存postCode
      if (isAddress(data)) {
        // 判断postCode是否在配送范围内 isDefaultLocal判断是因为如果默认兜底地址不展示postcode 则不需要展示是否可配送
        getPostCodeDeliverable(data?.postCode);
        return;
      }
    });
  }

  const getPostCodeDeliverable = async (postCodeValue: string) => {
    if (!postCodeValue) {
      setIsNotDeliverable(false);
      return;
    }
    
    const currentCountry = countryStore.currentCountryData;
    
    if (!currentCountry) {
      setIsNotDeliverable(false);
      return;
    }
    
    const [err, result] = await to(
      queryPostCode({ 
        postCode: postCodeValue, 
        checkDeliverableFlag: true,
        countryId: currentCountry?.countryId,
        countryCode: currentCountry?.countryCode
      }),
    );
    if (result?.code === "200" && result?.data) {
      setPostCodeAddress(result?.data);
      setIsNotDeliverable(result?.data?.isDeliverable === false);
      return;
    }
    setIsNotDeliverable(false);
  };

  return (
    <>
      {isNotDeliverable && postCodeAddress?.tipsInfo?.showText ? (
        <div className={styles.container}>
          <span><LocationError /></span>
          <span className={styles.text}>{postCodeAddress?.tipsInfo?.showText}</span>
          <span className={styles.right} onClick={() => setIsOpenDialog(true)}>{postCodeAddress?.tipsInfo?.clickText} <AddressArrow /></span>
          <AddressSelectDrawer
            openDrawer={isOpenDialog}
            setOpenDrawer={setIsOpenDialog}
          />
        </div>
      ) : null}
    </>
  );
});

export default FloatBottomTips;
